import { BASE_URL } from './config';

let accessToken = null;
let refreshToken = null;
let refreshPromise = null;

export const getAccessToken = () => {
    // Сначала проверяем память, затем localStorage
    if (accessToken) return accessToken;
    return localStorage.getItem('accessToken');
};

export const setAccessToken = (token) => {
    accessToken = token;
    localStorage.setItem('accessToken', token);
    window.dispatchEvent(new Event('authChange'));
};

export const clearAccessToken = () => {
    accessToken = null;
    localStorage.removeItem('accessToken');
    window.dispatchEvent(new Event('authChange'));
};

export const getRefreshToken = () => {
    if (refreshToken) return refreshToken;
    return localStorage.getItem('refreshToken');
};

export const setRefreshToken = (token) => {
    refreshToken = token;
    localStorage.setItem('refreshToken', token);
};

export const clearRefreshToken = () => {
    refreshToken = null;
    localStorage.removeItem('refreshToken');
};

export const clearAuthTokens = () => {
    clearAccessToken();
    clearRefreshToken();
};

export const isTokenExpired = (token) => {
    if (!token || typeof token !== 'string') return true;
    const parts = token.split('.');
    if (parts.length !== 3) return true;

    try {
        const payload = JSON.parse(atob(parts[1]));
        return !payload.exp || payload.exp * 1000 < Date.now();
    } catch (e) {
        return true;
    }
};

const abortTimeout = (ms) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), ms);
    return { signal: controller.signal, cleanup: () => clearTimeout(timeoutId) };
};

export const refreshSession = async () => {
    if (refreshPromise) {
        return refreshPromise;
    }

    refreshPromise = (async () => {
        const { signal, cleanup } = abortTimeout(10000);
        const currentRefreshToken = getRefreshToken();

        try {
            const response = await fetch(`${BASE_URL}/auth/refresh-token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(currentRefreshToken ? { 'Refresh-Token': currentRefreshToken } : {})
                },
                credentials: 'include',
                signal
            });

            if (response.ok) {
                const { accessToken: newAccessToken, refreshToken: newRefreshToken } = await response.json();
                setAccessToken(newAccessToken);
                if (newRefreshToken) setRefreshToken(newRefreshToken);
                return newAccessToken;
            }

            clearAuthTokens();
            throw new Error('Failed to refresh token');
        } finally {
            cleanup();
            refreshPromise = null;
        }
    })();

    return refreshPromise;
};

export const onAuthChange = (callback) => {
    window.addEventListener('authChange', callback);
    return () => window.removeEventListener('authChange', callback);
};


